import events from '../../constants/events';
import { dispatchEvent } from '../../utilities/customEvents';

import { Base } from './Base';

const classes = {
  contentFixedTrigger: 'product-detail__content-fixed-trigger',
  contentStuckTrigger: 'product-detail__content-stuck-trigger',
  fixed: 'fixed',
  stuck: 'stuck'
};

export class ProductDetailContent extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.init();
  }

  init() {
    this.addScrollHandlerSubscriptions();
    this.bindTriggeredListeners();
  }

  addScrollHandlerSubscriptions() {
    dispatchEvent(window, events.ADD_SCROLL_SUBSCRIPTION, {
      selector: '.' + classes.contentFixedTrigger,
      eventName: events.SCROLL_HANDLER_TRIGGERED
    });

    dispatchEvent(window, events.ADD_SCROLL_SUBSCRIPTION, {
      selector: '.' + classes.contentStuckTrigger,
      eventName: events.SCROLL_HANDLER_TRIGGERED
    });
  }

  bindTriggeredListeners() {
    const contentFixedTrigger = document.querySelector('.' + classes.contentFixedTrigger);
    const contentStuckTrigger = document.querySelector('.' + classes.contentStuckTrigger);

    if (contentFixedTrigger) {
      contentFixedTrigger.addEventListener(events.SCROLL_HANDLER_TRIGGERED, (e) => {
        this.handleFixedTrigger(e.detail.direction);
      });
    }

    if (contentStuckTrigger) {
      contentStuckTrigger.addEventListener(events.SCROLL_HANDLER_TRIGGERED, (e) => {
        this.handleStuckTrigger(e.detail.direction);
      });
    }
  }

  handleFixedTrigger(direction) {
    if (direction === 'down') {
      this.element.classList.add(classes.fixed);
    } else {
      this.element.classList.remove(classes.fixed);
    }
  }

  handleStuckTrigger(direction) {
    if (direction === 'down') {
      this.element.classList.add(classes.stuck);
    } else {
      this.element.classList.remove(classes.stuck);
    }
  }
}